// 环境变量优先级
// npm start: .env.development.local, .env.development, .env.local, .env
// npm run build: .env.production.local, .env.production, .env.local, .env
// npm test: .env.test.local, .env.test, .env (note .env.local is missing)
import Env from "@util/env"
let hostName = window.location.host.split(".")
hostName[0] = "dmp"
export const BI_URL = process.env.REACT_APP_BI
export const CLOUD_API = process.env.REACT_APP_API_CLOUD
export const CLOUD_ORDER_API = process.env.REACT_APP_API_CLOUD
export const PRODUCT_URL = window.location.protocol + "//" + hostName.join(".")
export const API_BI_CLOUD = process.env.REACT_APP_API_BI_CLOUD
export const COOKIE_DOMAIN = window.location.host
  .replace(/:\d+$/, "")
  .replace(/^[\w-]+/, "")

// @ts-ignore
export const IS_MICRO = window.__POWERED_BY_QIANKUN__
export const URL_DASHBOARD =
  (IS_MICRO ? window.location.origin : process.env.REACT_APP_URL_CLOUD) +
  "/dashboard/#"
export const URL_PASSPORT =
  (IS_MICRO ? window.location.origin : process.env.REACT_APP_URL_CLOUD) +
  "/passport/#"
export const URL_BILL =
  (IS_MICRO ? window.location.origin : process.env.REACT_APP_URL_CLOUD) +
  "/bill/#"

export const getDashboardUrl = () => {
  const user = Env.getUser()
  return user.potoken ? URL_DASHBOARD : URL_PASSPORT + "/login"
}
